import {Container, CssBaseline} from '@mui/joy'
import {Outlet} from 'react-router-dom'
import * as React from 'react'
import GlobalStyles from '@mui/joy/GlobalStyles'
import Box from '@mui/joy/Box'
import Sheet from '@mui/joy/Sheet'

function Panel() {
  return (
    <>
      <CssBaseline/>
      <Box sx={{display: 'flex', minHeight: '100dvh'}}>
        <Box
          sx={{
            flexGrow: 1,
            p: 2,
          }}
        >
          <Container
            sx={{
              pt: {
                xs: 'calc(12px + var(--Header-height))',
                sm: 'calc(12px + var(--Header-height))',
              },
            }}
          >
            <Outlet/>
          </Container>
        </Box>
      </Box>

      <Sheet
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'fixed',
          top: 0,
          width: '100vw',
          height: 'var(--Header-height)',
          zIndex: 9998,
          p: 2,
          gap: 1,
          borderBottom: '1px solid',
          borderColor: 'background.level1',
          boxShadow: 'sm',
        }}
      >
        <GlobalStyles
          styles={(theme) => ({
            ':root': {
              '--Header-height': '52px',
            },
          })}
        />
        {localStorage.getItem("customerName")}
      </Sheet>
    </>
  )
}

export default Panel
